/* eslint-disable */
export default {
  title: 'Cronologia',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
